import { render, staticRenderFns } from "./ProductBundleWarning.vue?vue&type=template&id=423c4be4&"
import script from "./ProductBundleWarning.vue?vue&type=script&lang=ts&"
export * from "./ProductBundleWarning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports